'use client';

import type { WrapperProps } from './types';

export default function Wrapper({
    children,
    className,
    style,
    ...rest
}: WrapperProps) {
    return (
        <div
            className={className}
            style={style}
            {...rest}
        >
            {children}
        </div>
    );
}
